import '@popperjs/core';
// import 'bootstrap';
// required to get bootstrap available in the window (like tooltips that are disabled by default)
// and default-active bootstrap-js (like dropdowns)
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import Chart from 'chart.js/auto';
window.Chart = Chart
